import { translate } from '@lwtears/lwt-common-frontend/lib/@common/util';
import { Resource, ResourceFilter } from '../providers/ResourcesProvider/types';

const getResourcesTranslation = (key) => translate('resources', key);
const getCommonTranslation = (key) => translate('common', key);

function _searchInAttribute(value: string | undefined, searchText: string): boolean {
  return value ? value.toString().toLowerCase().indexOf(searchText.toLowerCase()) >= 0 : false;
}

function _searchInArray(array: Array<any>, attributes: Array<string>, searchText: string): boolean {
  return (
    array !== undefined &&
    array !== null &&
    array.some((item) => {
      return attributes.some((attribute) => {
        return _searchInAttribute(item[attribute], searchText);
      });
    })
  );
}

export function filterResourcesByText(
  resources: Array<Resource>,
  searchText: string
): Array<Resource> {
  return resources.filter((resource) => {
    return (
      _searchInAttribute(resource.title, searchText) ||
      _searchInAttribute(resource.description, searchText) ||
      _searchInArray(resource.tags, ['tag', 'value'], searchText)
    );
  });
}

export function filterResourceByTag(resource: Resource, filters: Array<ResourceFilter>): boolean {
  if (resource.tags && resource.tags.length > 0) {
    let intersects = false;

    for (let i = 0, len = resource.tags.length; i < len; i++) {
      const x = resource.tags[i];

      if (filters.findIndex((tag) => tag.id === x.id) >= 0) {
        intersects = true;
      }
    }

    return intersects;
  }

  return false;
}

export function constructDropDownFilterInput(
  selectedFilters: Array<ResourceFilter>,
  allFilters: Array<ResourceFilter>,
  label: string
): string | number {
  let filterText = getCommonTranslation('allOption');

  if (selectedFilters) {
    if (label === getResourcesTranslation('resourceType')) {
      const relevantTags = selectedFilters.filter((selectedFilter) =>
        allFilters.find((filter) => filter.id === selectedFilter.id)
      );
      if (relevantTags.length > 0) {
        filterText =
          relevantTags.length === 1 ? relevantTags[0].value : relevantTags.length.toString();
      }
    } else {
      filterText = selectedFilters.reduce((acc, selectedFilter) => {
        const matchingFilter = allFilters.find((filter) => filter.id === selectedFilter.id);
        if (matchingFilter !== undefined) {
          if (acc === getCommonTranslation('allOption')) {
            return (acc = matchingFilter.value);
          } else {
            return (acc = acc + ', ' + matchingFilter.value);
          }
        }
        return acc;
      }, filterText);
    }
  }

  return filterText;
}

export function sortResourceByTitle(resources: Resource[]) {
  return resources.slice().sort((resourceA, resourceB) => {
    const titleA = resourceA.title.toUpperCase();
    const titleB = resourceB.title.toUpperCase();
    return titleA < titleB ? -1 : titleA > titleB ? 1 : 0;
  });
}
